<ng-container *ngIf="{
	bins: itembins$ | async,
	movements: movements$ | async,
	locations: locations$ | async,
	config: config$ | async,
	uiState: uiState$ | async,
	totalQoh: totalQoh$ | async,
	binsList: bins$ | async
} as vm">

<div class="row mt-2">

	<div class="col-md-3">
		<h5>
			<b>Bins</b>&nbsp;<span *ngIf="vm.bins">({{ vm.bins.length }})</span>
			<button mat-icon-button (click)="updateUiState({ showAddBinInput: !vm.uiState.showAddBinInput })">
				<mat-icon>add</mat-icon>
			</button>
		</h5>
		<div *ngIf="vm.uiState.showAddBinInput">
			<input [(ngModel)]="newBinValue" placeholder="Enter new bin" class="form-control d-inline-block w-60" [disabled]="vm.uiState.savingBin" />
			<button mat-icon-button (click)="createBin()" [disabled]="vm.uiState.savingBin">
				<mat-icon>{{ vm.uiState.savingBin ? 'hourglass_empty' : 'check' }}</mat-icon>
			</button>
			<button mat-icon-button (click)="updateUiState({ showAddBinInput: false })" [disabled]="vm.uiState.savingBin">
				<mat-icon>cancel</mat-icon>
			</button>
		</div>
		<div class="table" *ngIf="vm.bins && vm.bins.length">
			<table class="table table-fixed table-sm">
				<thead>
					<tr>
						<th class="text-left">BIN</th>
						<th class="text-center">QTY</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let bin of vm.bins; trackBy: trackByBin">
						<td>
							<ng-container *ngIf="vm.uiState.editingBin === bin.bin && bin.bin !== ''; else viewMode">
								<input [(ngModel)]="editingBinValue" class="form-control d-inline-block text-right" [disabled]="vm.uiState.savingBin || vm.uiState.removingBin" />
								<div class="button-group">
									<button mat-icon-button class="save-button" (click)="saveBin(bin)" [disabled]="vm.uiState.savingBin || vm.uiState.removingBin">
										<mat-icon>{{ vm.uiState.savingBin ? 'hourglass_empty' : 'save' }}</mat-icon>
									</button>
									<button mat-icon-button class="cancel-button" (click)="cancelEdit()" [disabled]="vm.uiState.savingBin || vm.uiState.removingBin">
										<mat-icon>cancel</mat-icon>
									</button>
									<button mat-icon-button class="remove-button" (click)="removeBin(bin)" [disabled]="vm.uiState.savingBin || vm.uiState.removingBin">
										<mat-icon>{{ vm.uiState.removingBin ? 'hourglass_empty' : 'remove' }}</mat-icon>
									</button>
								</div>
							</ng-container>

							<ng-template #viewMode>
								<button mat-icon-button (click)="selBin(bin.bin)" *ngIf="bin.bin !== ''" [disabled]="vm.uiState.savingBin || vm.uiState.removingBin">
									<mat-icon>add_box</mat-icon>
								</button>
								{{ bin.bin === '' ? 'N/A' : bin.bin }}
								<ng-container *ngIf="vm.config?.env?.package !== 'tires' && bin.bin !== ''">
									<button mat-icon-button (click)="editBin(bin)" [disabled]="vm.uiState.savingBin || vm.uiState.removingBin">
										<mat-icon>edit</mat-icon>
									</button>
								</ng-container>
							</ng-template>
						</td>
						<td class="text-center">{{ bin.quantity }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<ng-container *ngIf="!vm.bins || !vm.bins.length">
			<h4>NO BIN'S</h4>
		</ng-container>
	</div>





	<div class="col-md-9">
		<ng-container *ngIf="adjustmentForm">
			<h5><b>Adjustment</b></h5>
			<div class="card">
				<div class="card-body">
					<form [formGroup]="adjustmentForm" autocomplete="off">
						<div class="row">
							<div class="col-md-12">
								<mat-form-field appearance="outline">
									<mat-label>Warehouse</mat-label>
									<mat-select formControlName="loccode">
										<mat-option *ngFor="let loc of vm.locations; trackBy: trackByLocation" [value]="loc.loccode">
											{{ loc.locationname }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field appearance="outline">
									<mat-label>Bin to Adjust</mat-label>
									<input matInput autofocus formControlName="bin" id="bin" #binInput [matAutocomplete]="binLookup" (keydown.enter)="$event.preventDefault();" (focus)="selectText(binInput)" />
									<mat-autocomplete #binLookup="matAutocomplete">
										<mat-option *ngFor="let v of vm.binsList" [value]="v.bin">
											{{ v.bin }}
										</mat-option>
									</mat-autocomplete>
									<mat-hint *ngIf="!binExists()">Creating New Bin</mat-hint>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="text-center">
									<mat-label>Qty</mat-label>
									<input matInput formControlName="qty" type="text" #qty id="qty" />
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="text-center" [ngClass]="{'d-none': this.hidecost}">
									<mat-label>Cost</mat-label>
									<input matInput formControlName="cost" type="text" />
								</mat-form-field>
							</div>
							<div class="col-md-5" *ngIf="empid_required">
								<mat-form-field appearance="outline" class="text-center">
									<mat-label>Employee ID</mat-label>
									<input matInput formControlName="empid" type="text" id="empid"/>
									<mat-error *ngIf="!validEmp && adjustmentForm.get('empid')?.value.length">Invalid Employee ID</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-10">
								<mat-form-field appearance="outline">
									<mat-label>Adjustment Reason</mat-label>
									<input matInput formControlName="reason" type="text" #reason />
								</mat-form-field>
							</div>
							<div class="col-md-2 text-center">
								<button mat-raised-button n-submit color="warn" class="mt-3" (click)="addMovement()" [disabled]="vm.uiState.sending || !adjustmentForm.valid || (empid_required && (validatingEmpCode || !validEmp))">
									<mat-icon>add</mat-icon> Add
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</ng-container>
	</div>
</div>


<ng-container *ngIf="vm.movements && vm.movements.length">
	<h5><b>Adjustments</b></h5>
	<div class="row">
		<div class="col-9">
			<div class="table">
				<table class="table table-fixed table-sm">
					<thead>
						<tr>
							<th class="text-left">BIN</th>
							<th class="text-left">Reason</th>
							<th class="text-center">QTY</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let move of vm.movements; trackBy: trackByMovement">
							<td class="text-left">
								<button mat-button color="accent" (click)="removeMovement(move)">
									<mat-icon>remove_circle</mat-icon> {{move.bin}}
								</button>
							</td>
							<td class="text-left">{{move.reason}}</td>
							<td class="text-center">{{move.qty}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="col-3 text-right">
			<h5>NEW QOH {{ vm.totalQoh | number:'1.0-2' }} </h5>
			<button mat-raised-button [color]="vm.movements.length ? 'accent': 'warn'" [disabled]="vm.uiState.sending" (click)="makeAdjustment()">
				Adjust Stock
			</button>
		</div>
	</div>
</ng-container>

</ng-container>